/*
|----------------------------------------------------------
|   Forms:
|---------------------------------------------------------
|   All functions related to adding form support for Pjax.
|
*/

/**
 * Import config
 */
import config from "./config";

export default {

    /**
     * Captures search forms response and loads
     * the page via Barba.Pjax.goTo()
     */
    searchForms: function() {
        if (config.debug) console.log('searchForms')

        /**
         * Add all search form classes to select forms
         */
        var formsClasses = '.pjax-container .ee-search-form'
        var flyOutSearch = jQuery('.audio-player-flyout-wrapper .ee-search-form')
        /**
         * Get search form modal when needed
         */
        var searchModal = jQuery('.ee-search-form__overlay')

        jQuery(formsClasses).on('submit', function (e) {
            console.log('hit from search');
            // Only run on pjax sites
            if (jQuery('body').hasClass('pjax')) {
                e.preventDefault()
                // close search form modal when present
                if (searchModal.length) {
                    searchModal.hide()
                }

                // Navigate via pjax to search results
                Barba.Pjax.goTo(e.target.action + '?' + jQuery(this).serialize())

            }
        })

        // Append an error message if user tries to use a search form
        // in the player flyout
        if (flyOutSearch.length) {
            flyOutSearch.parent().html('<p style="color:white;font-size:16px;padding:4px;background-color;background-color: red;border-radius:4px;">Error: search forms can not be added to the player tray.</p>')
        }
    }

}
